import {
  EventActionTypes,
  EventPersonalDetails,
  EventBusinessDetails,
  EventDetailsInfo,
  EventBookingConfirmation,
} from './reducer';

export const setEventIdState = (eventId: string): Action => ({
  type: EventActionTypes.SET_EVENT_ID,
  payload: eventId,
});

export const setEventPersonalDetailsState = (personalDetails: EventPersonalDetails): Action => ({
  type: EventActionTypes.SET_PERSONAL_DETAILS,
  payload: personalDetails,
});

export const setEventBusinessDetailsState = (businessDetails: EventBusinessDetails): Action => ({
  type: EventActionTypes.SET_BUSINESS_DETAILS,
  payload: businessDetails,
});

export const setEventDetailsState = (eventDetails: EventDetailsInfo): Action => ({
  type: EventActionTypes.SET_EVENT_DETAILS,
  payload: eventDetails,
});

export const setEventBookingConfirmationState = (bookingConfirmation: EventBookingConfirmation): Action => ({
  type: EventActionTypes.SET_BOOKING_CONFIRMATION,
  payload: bookingConfirmation,
});

export const setEventConsentState = (hasGivenConsent: boolean): Action => ({
  type: EventActionTypes.SET_CONSENT,
  payload: hasGivenConsent,
});
